module.exports = __webpack_public_path__ + "img/favorite.eddf6cb3.jpg";